import { render, staticRenderFns } from "./EditRequestedGenericCODStatus.vue?vue&type=template&id=24babb22&scoped=true"
import script from "./EditRequestedGenericCODStatus.vue?vue&type=script&lang=js"
export * from "./EditRequestedGenericCODStatus.vue?vue&type=script&lang=js"
import style0 from "./EditRequestedGenericCODStatus.vue?vue&type=style&index=0&id=24babb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24babb22",
  null
  
)

export default component.exports